<template lang="pug">
  section.scene-opening
    transition( name="headline" )
      headline(
        v-if="displayStatus==='headline'",
        :en="headline.en",
        :jp="headline.jp"
      )

    transition( name="description" )
      .contents( v-if="displayStatus==='contents'" )
        step-message(
          v-if="step===1",
          @onFix="onStepMessage_Fix"
        )
        step-purpose(
          v-if="step===2",
          @onFix="onStepPurpose_Fix"
        )
</template>

<script>
import GameMain from "../game/GameMain";
import Common from "./mixins/Common";

import Headline from "./Headline";
import StepMessage from "./scene_opening/StepMessage";
import StepPurpose from "./scene_opening/StepPurpose";

export default {
  mixins: [Common],

  components: {
    Headline,
    StepMessage,
    StepPurpose
  },

  watch: {
    step: function(val) {
      //send GA Events
      this.$ga.page("/scene_opening/" + val);

      switch (val) {
        case 1:
          this.headline.en = "HELLO,2019";
          this.headline.jp = "こんにちは、2019年";

          setTimeout(() => {
            this.showHeadline();
          }, 4000);

          GameMain.sceneOpening_changeStep(val);
          break;
        case 2:
          this.headline.en = "What's your Goal<br/>for this year?";
          this.headline.jp = "2019年あなたの目標は何？";

          this.showHeadline();
          GameMain.sceneOpening_changeStep(val);
          break;
        case 3:
          this.headline.en = "";
          this.headline.jp = "";

          GameMain.sceneOpening_changeStep(val);
          break;
      }
    }
  },

  mounted() {
    this.step = 1;
  },

  methods: {
    onStepMessage_Fix() {
      this.step++;
    },

    onStepPurpose_Fix(purpose) {
      GameMain.sceneOpening_changePurpose(purpose);

      this.step++;

      if (this.step == 3) {
        this.$emit("onSceneNext", this.step);
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>
